import { useCallback, useEffect, useState } from "react";
import { usePermissions } from "../Auth/PermissionsContext";
import { fetchTaskCount } from "../Components/Redirects/redirectsApi";

const POLL_INTERVAL_MS = 60_000;

/**
 * Compteur des tâches de cohérence des liens OUVERTES en PRODUCTION (des erreurs visibles par le
 * public) pour la pastille rouge « Redirections » de la barre latérale. Aucun événement temps réel
 * n'existe pour ces tâches : on interroge GET /api/redirects/tasks/count toutes les 60 s, plus un
 * rafraîchissement au retour de focus sur la fenêtre. Zéro quand l'admin ne peut pas lire la page.
 */
export function useRedirectBadge(): number {
	const { can } = usePermissions();
	const allowed = can("feature:redirections:read");
	const [count, setCount] = useState(0);

	const refresh = useCallback(() => {
		if (!allowed) {
			setCount(0);
			return;
		}
		fetchTaskCount()
			.then((counts) => setCount(Number.isFinite(counts.production) ? counts.production : 0))
			.catch(() => {
				/* on garde le dernier compte connu en cas d'erreur transitoire */
			});
	}, [allowed]);

	useEffect(() => {
		refresh();
		const interval = window.setInterval(refresh, POLL_INTERVAL_MS);
		const onFocus = () => refresh();
		window.addEventListener("focus", onFocus);
		return () => {
			window.clearInterval(interval);
			window.removeEventListener("focus", onFocus);
		};
	}, [refresh]);

	return count;
}
